import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    dependences: []
};
export const pluginEditorSlice = createSlice({
    name: 'pluginEditor',
    initialState: initialState,
    reducers: {
        setReferences: (state, action) => {
            state.dependences = action.payload || [];
        }
    }
});
